import { Divider } from '@knack/asterisk-react';

import type { Credentials } from '@/types/auth';
import { AuthForm } from '@/components/auth-form';
import { GoogleButton } from '@/components/ui/GoogleButton';
import type { QuestionnaireData } from '@/pages/sign-up/onboarding/types';

interface SignUpFormProps {
  canContinueGoogle: boolean;
  onSuccessfulGoogleValidation: (userExists: boolean) => void;
  questionnaireData: QuestionnaireData | undefined;
  onSubmit: (data: Credentials) => void;
  signUpError: string;
  isLoading: boolean;
}

export function SignUpForm({
  canContinueGoogle,
  onSuccessfulGoogleValidation,
  questionnaireData,
  onSubmit,
  signUpError,
  isLoading
}: SignUpFormProps) {
  return (
    <>
      <div className="mt-8 flex items-center justify-center">
        <GoogleButton
          isSignUp
          canContinue={canContinueGoogle}
          onSuccessfulValidation={onSuccessfulGoogleValidation}
          questionnaireData={questionnaireData}
        />
      </div>

      <Divider className="mb-10" text="or" />

      <AuthForm
        isSignUp
        onSubmit={onSubmit}
        submissionError={signUpError}
        className="mb-6"
        isLoading={isLoading}
      />
    </>
  );
}
